<template>
    <a-carousel arrows ref="parentsDom">
        <div slot="prevArrow" slot-scope="props" class="custom-slick-arrow" style="left: 10px;zIndex: 1">
            <a-icon type="left" />
        </div>
        <div slot="nextArrow" slot-scope="props" class="custom-slick-arrow" style="right: 10px">
            <a-icon type="right" />
        </div>
        <div class="artwork-box" v-for="item in carouselData" :key="item.num">
            <div class="artwork-link" :href="item.href" target="_blank">
                <div class="artwork-con">
                    <a :href="item.href" target="_blank">
                        <img class="artwork-img" v-lazy="item.img" />
                    </a>
                </div>
                <div class="artwork-mess-box">
                    <div class="artwork-disc-chinese">
                        <p class="info" v-if="item.words">"{{item.words}}</p>
                        <p class="info" v-if="item.chinese">{{item.chinese}}"</p>
                    </div>
                    <p class="info">《{{item.title}}》{{item.artist}} {{item.caizhi}} {{item.size}} {{item.year}}</p>
                </div>
                
            </div>
        </div>
    </a-carousel>
</template>
<script>
import VueLazyload from 'vue-lazyload';
export default {
    props: ['artwork'],
    data() {
        return {
            carouselData: this.artwork,
            imgSizes: [],
            parentWidth:0,
            parentHeight:0,
            isHeight: false,
            t:0,
            l:0,
            w:0,
            h:0
        };
    },
};
</script>
<style scoped>
.artwork-mess-box{
    position: absolute;
    bottom: 0;
    left: 15%;
    width: 70%;
}
/* For demo */
.ant-carousel{
    position: relative;
    z-index: 1;
}
.ant-carousel >>> .slick-slide {
    /* height: 220px; */
    overflow: hidden;
}

.ant-carousel >>> .custom-slick-arrow {
    width: 50px;
    height: 50px;
    font-size: 40px;
    color: #fff;
    background-color: rgba(31, 45, 61, 0.11);
    opacity: 0.8;
    top:50%;
}
.ant-carousel >>> .custom-slick-arrow:before {
    display: none;
}
.ant-carousel >>> .custom-slick-arrow:hover {
    opacity: 0.5;
}

.ant-carousel >>> .slick-slide h3 {
    color: #fff;
}
.ant-carousel >>> .slick-dots li {
    display: none !important;
}
.ant-carousel .artwork-box {
    width: 100%;
    height: 0;
    padding-bottom: 47%;
}
.ant-carousel .artwork-link {
    width: 100%;
    height: 0;
    padding-bottom: 47%;
    display: block;
    position: relative;
}
.ant-carousel .artwork-con {
    position: relative;
    width: 100%;
    height: 0;
    padding-bottom: 42%;
    display: inline-block;
    
}
.ant-carousel .artwork-img {
    position: absolute;
    width: auto;
    max-height: 100%;
    max-width: 100%;
    top: 0px;
    bottom:0px;
    left: 0px;
    right: 0px;
    margin:auto;
}

.artwork-link .info{
    color: #fff;
    font-size: 16px;
    padding: 0 4%;
    transform: scale(0.9);
    max-height: 55px;
    overflow: hidden;    
    text-align: center;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    text-overflow: ellipsis;
}
</style>
